/*
 * @Author: Ztq
 * @Date: 2022-05-13 16:49:55
 * @LastEditors: luckymiaow
 * @LastEditTime: 2022-07-12 15:21:20
 * @Description:
 * @FilePath: \ch2-template-vue\src\components\common\input-money\types.ts
 */
import type { InputNumberInjectConfig } from '../input-number/types';

export type IInputMoneyProps = InputNumberInjectConfig;

export enum UnitType {
  元 = 100,
  百 = 10000,
  千 = 100000,
  万 = 1000000,
  千万 = 10000000,
  亿 = 100000000,
}
